<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')" style="cursor: pointer">Control Interno</li>
        <li class="breadcrumb-item active" aria-current="page">Panel de Cumplimiento</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <vx-card title="Reporte panel de cumplimiento">
          <div class="skinny row">
              <div class="col-md-4">
                  <vs-select
                  placeholder="Seleccione"
                  label="Requerimientos"
                  class="w-full"
                  v-model.lazy="requirementSelected"
                  >
                  <vs-select-item :key="index" :value="item" :text="item.requirement" v-for="(item,index) in validRequirements" />
                  </vs-select>
              </div>
              <div class="col-md-4">
                  <vs-select
                  placeholder="Seleccione"
                  label="Tags"
                  class="w-full"
                  :disabled="requirementSelected.mandatory_tags.length == 0"
                  v-model.lazy="tagSelected"
                  >
                  <vs-select-item :key="index" :value="item.tag" :text="item.tag" v-for="(item,index) in requirementSelected.mandatory_tags" />
                  </vs-select>
              </div>
              <div class="col-md-2">
              <div class="flex flex-wrap">
                  <vs-button :disabled="!tagSelected" @click="getRequirementData" color="dark" class="mt-6">Consultar</vs-button>
                  </div>
              </div>
          </div>
          <div class="vx-row" v-if="currentRequirementData">
              <div class="vx-col w-full">
                <h5 class="bold mt-6 mb-5">Resultados de la consulta:</h5>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <div class="vx-col w-full">
                    <statistics-card-line
                      hideChart
                      class="mb-base"
                      icon="DollarSignIcon"
                      :withIcon="false"
                      statisticTitle="Usuarios que aplican"
                      :statistic="currentRequirementData? numberFormat(currentRequirementData.total_users):0" />
                </div>
                <div class="vx-col w-full">
                      <statistics-card-line
                      hideChart
                      class="mb-base"
                      icon="DollarSignIcon"
                      :withIcon="false"
                      textColor="#43a047"
                      :statistic="currentRequirementData? numberFormat(currentRequirementData.complete_users):0"
                      statisticTitle="Usuarios que cumplen" />
                </div>
                <div class="vx-col w-full">
                      <statistics-card-line
                      hideChart
                      class="mb-base"
                      icon="DollarSignIcon"
                      :withIcon="false"
                      textColor="#CB4335"
                      :statistic="currentRequirementData? numberFormat(currentRequirementData.incomplete_users):0"
                      statisticTitle="Usuarios que no cumplen" />
                </div>              
              </div>
              <div class="vx-col w-full lg:w-2/3">
                <vue-apex-charts v-if="!ignoreChart" type="donut" height="350" :options="chartOptions" :series="chartSeries"></vue-apex-charts>
              </div>
          </div>
      </vx-card>
    </div>
  </div>

</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import VueApexCharts from 'vue-apexcharts';

const columnDefinitions = [
  { title: "USUARIOS TOTALES", key: "total_users"},
  { title: "USUARIOS QUE HAN CUMPLIDO", key: "complete_users"},
  { title: "USUARIOS QUE NO HAN CUMPLIDO", key: "incomplete_users"},  
];
export default  {
  name: 'compliance-panel-report',
  mixins: [formatHelper],
  components: {VueApexCharts},
  async mounted() {
    await this.getRequirementsList();
  },
  data() {
    return {
      columns: columnDefinitions,
      validRequirements: [],
      requirementSelected: {
        mandatory_tags:[]
      },
      tagSelected: null,
      requirementTags: [],
      currentRequirementData:null,
      chartSeries: [{
        name: "Usuarios",
        data: []
      }],
      chartOptions: {
        colors: ['#f9a01b'],
        dataLabels: { enabled: false },
        donut: { labels: { show: false} },
        legend: { show: false},
        tooltip: { y: { formatter: (value) =>{return value} } },
        labels: [],
      },
      ignoreChart:false
    }
  },
  methods: {
    async getRequirementsList(){
      this.showLoading(true);
      await axios.get( '/api/catalogs/compliance_requirements').then(response => {
        var requirements = response.data.data;
        requirements.forEach(req => {
          if (req.mandatory_tags) {
            this.validRequirements.push(req);
          }
        });
        this.showLoading(false);
      });
    },
    async getRequirementData(){
      this.showLoading(true);
      await axios.post('/api/compliance/report', {
          requirement_id: this.requirementSelected.id,
          tag: this.tagSelected,
      }).then(response => {
          this.currentRequirementData=response.data;
          let series = [];
          let labels = [];
          let colors = [];
          series.push(this.currentRequirementData.complete_users);
          series.push(this.currentRequirementData.incomplete_users);
          labels.push("Usuarios que cumplen");
          labels.push("Usuarios que no cumplen");
          colors.push("#43a047");
          colors.push("#CB4335");
          this.chartSeries = series;
          this.chartOptions = { labels: labels, colors: colors };
          if(!series.length){
            this.ignoreChart = true;
          }
          this.showLoading(false);
      }).catch(error => {
          this.showLoading(false);
      });
    }
  }
}
</script>